import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getUserSettings, saveNotificationSettings } from '../user-profile';
import { FREQUENCY_NEVER, FORTNIGHTLY_VARIANTS, frequencyOptions, terms } from '../../constants/notifications';

export const useNotificationSettings = () => {
    return useQuery({
        queryKey: ['notificationSettings'],
        queryFn: getUserSettings,
        select: (response) => {
            const frequencyValue = response.EmailNotificationFrequency?.value;
            const normalizedValue = FORTNIGHTLY_VARIANTS.includes(frequencyValue) ? terms.fortnightly : frequencyValue;
            const frequencyOption = frequencyOptions.find(opt => opt.value === normalizedValue) || FREQUENCY_NEVER;
            const isChecked = frequencyValue !== undefined && frequencyValue !== FREQUENCY_NEVER.value;
            const id = response.EmailNotificationFrequency?.id;
            return {
                checkbox: isChecked,
                frequency: frequencyOption,
                hasSettings: frequencyValue !== undefined,
                id,
            };
        }
    });
};

export const useSaveNotificationSettings = () => { 
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ selectedFrequency, hasSettings, id }) => saveNotificationSettings(selectedFrequency, hasSettings, id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['notificationSettings'] });
        }
    });
};
